import {useContext, useState, useEffect} from "react"
import styles from "./VoiceCallStudentPanel.module.css"
import {VoiceCallContext} from "context/VoiceCallContext"
import {UserAvatar} from "sections/NewCommunication/shared"
import cx from "classnames"
import {BASE_DEPARTMENT_NAME} from "types/departments"
import {Settings} from "types/settings"
import moment from "moment"
import {ReactComponent as DialerIcon} from "./assets/dialer.svg"
import {Icon} from "components/Icon"
import {Tooltip} from "antd"
import {openLinkInNewTab} from "helpers"

export function VoiceCallStudentPanel() {
    const {
        calling,
        activeStudent,
        callStatus,
        isConnected,
        hangup,
        queuedStudents,
        isAuto,
        activeDepartmentId,
        voiceProvider,
        isIncomingCall,
        rejectCall,
        acceptCall,
        isInTransitionCall,
        transitionCountdown,
        connectedTime,
        forceCloseCall
    } = useContext(VoiceCallContext)
    const [elapsed, setElapsed] = useState(0)

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null
        if (isConnected && connectedTime) {
            const updateElapsed = () => {
                setElapsed(moment().diff(moment(connectedTime), "seconds"))
            }
            updateElapsed()
            interval = setInterval(updateElapsed, 1000)
        } else {
            setElapsed(0)
        }
        return () => {
            if (interval) clearInterval(interval)
        }
    }, [isConnected, connectedTime])

    if ((queuedStudents.length === 0 && !calling) || !activeStudent) return null

    const nextStudent = queuedStudents?.[0]

    return (
        <div className={styles.container}>
            <Tooltip title="Close">
                <div className={styles.closeBtn} onClick={forceCloseCall}>
                    <Icon icon="CLOSE" color="#ffffff" className={styles.closeIcon} />
                </div>
            </Tooltip>
            <div className={styles.callContainer}>
                <UserAvatar user={activeStudent as any} className={styles.avatar} /> : <div />
                {isAuto ? <div className={styles.autoContainer}>Auto</div> : <div />}
            </div>
            {isInTransitionCall && transitionCountdown > 0 ? (
                <span className={styles.status}>next call in {transitionCountdown}s</span>
            ) : (
                <div className={styles.info}>
                    {activeDepartmentId && (
                        <div className={styles.departmentContainer}>{BASE_DEPARTMENT_NAME[activeDepartmentId]}</div>
                    )}
                    {activeStudent.campusName && (
                        <div className={styles.campusContainer}>
                            <Icon icon="LOCATION" color="#a0a0a0" className={styles.campusIcon} />
                            <span>{activeStudent.campusName}</span>
                        </div>
                    )}
                    {activeStudent.userId && (
                        <div
                            className={styles.nameWrap}
                            onClick={() => {
                                openLinkInNewTab(`/users/${activeStudent.userId}`)
                            }}>
                            <span className={styles.name}>{activeStudent.fullName}</span>
                            <Icon icon="EYE" color="#fff" className={styles.linkIcon} />
                        </div>
                    )}
                    <span className={styles.phone}>{activeStudent.phone}</span>
                    {isConnected && connectedTime && (
                        <span className={styles.connectedTime}>{moment.utc(elapsed * 1000).format("mm:ss")}</span>
                    )}
                    {isIncomingCall && !isConnected ? (
                        <>
                            <span className={styles.status}>calling you</span>
                            <div className={styles.incomingBtnWrap}>
                                <div className={styles.rejectBtn} onClick={() => rejectCall()}>
                                    Reject
                                </div>
                                <div className={styles.acceptBtn} onClick={() => acceptCall()}>
                                    Accept
                                </div>
                            </div>
                        </>
                    ) : (
                        <span className={styles.status}>{callStatus}...</span>
                    )}
                </div>
            )}
            {voiceProvider === Settings.DialerProvider.Twilio && !isInTransitionCall && !isIncomingCall && (
                <div className={cx(styles.btnWrap, styles.btnHangup)} onClick={() => hangup()}>
                    <DialerIcon className={styles.icon} />
                    <span className={styles.title}>Hang Up</span>
                </div>
            )}
            {nextStudent && (
                <div className={styles.nextContainer}>
                    <span className={styles.nextTitle}>Next: </span>
                    <span className={styles.nextStudent}>{nextStudent.fullName}</span>
                    <span className={styles.nextPhone}>{nextStudent.phone}</span>
                </div>
            )}
        </div>
    )
}
